import { useCallback } from "react";

import { getAll } from "../../api/generic-api";
import { InventoryItem } from "../../models";

export const useDuplicateInventoryItems = () => {
  return useCallback(async (name: string, inventoryItemId?: string) => {
    const params = new URLSearchParams({ name });
    if (inventoryItemId) {
      params.set("inventoryItemId", inventoryItemId);
    }

    return getAll<InventoryItem>(
      `inventory-items/duplicate-check?${params.toString()}`
    );
  }, []);
};
